import LoadingProgressBar from "@/components/loaders/loadingProgressBar"
import { useNavigationProgress } from "@/hooks/use-navigation-progress"

export function NavigationProgress() {
  const { isDone, progressKey } = useNavigationProgress()

  return (
    <div className="pointer-events-none fixed left-0 right-0 top-0 z-50">
      <LoadingProgressBar key={progressKey} isDone={isDone} />
    </div>
  )
}
